// I18n
import VueI18n from 'vue-i18n'
import ElementUI from 'element-ui'
import Vue from 'vue'
import locale from 'element-ui/lib/locale'

// 引入 elementui 的多语言
import enLocale from 'element-ui/lib/locale/lang/en'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
import idLocale from 'element-ui/lib/locale/lang/id'

// 引入自己定义的 I18n 文件
import myEn from './myEn.js'
import myZhCN from './myZh.js'
import myId from './myId.js'

// 注册 vue-i18n
Vue.use(VueI18n)
Vue.use(ElementUI)

var lang = localStorage.getItem('lang')
var islang = false
if (lang) {
  islang = true
}
// var language = navigator.language === 'zh-CN' ? 'zhCN' : 'en'
var language = 'en'

// 默认中文
const i18n = new VueI18n({
  // locale: navigator.language === 'zh-CN' ? 'zhCN' : 'en',
  locale: islang ? lang : language,
  messages: {
    zhCN: Object.assign(zhLocale, myZhCN),
    en: Object.assign(enLocale, myEn),
    id: Object.assign(idLocale, myId)
  },
  silentTranslationWarn: true // 去除国际化警告
})

locale.i18n((key, value) => i18n.t(key, value))

export default i18n



// WEBPACK FOOTER //
// ./src/language/i18n.js